export default "__VITE_ASSET__00668583__"